// extracted by mini-css-extract-plugin
module.exports = {"sorting":"Sorting_sorting__QDSdL","fadeIn":"Sorting_fadeIn__zxzwk","scaleXin":"Sorting_scaleXin__JfFSu"};